import { createContext, useContext } from 'react';

/**
 * Shared by Company.js and Contact.js: each provides its own shaped value
 * (save-callback registration, event handlers, and - for Contact.js only -
 * address/email/phone handlers). Consumers destructure only the keys they need.
 */
export const EntityEventContext = createContext({});

export const useEntityEventContext = () => useContext(EntityEventContext);
